import React, { useState, forwardRef } from 'react';
import classNames from 'classnames';
import styles from './Input.module.scss';
import EyeIcon from '../../../assets/icons/eye.svg';
import ShowEyeIcon from '../../../assets/icons/showEye.svg';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  showPasswordToggle?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { label, error, icon, showPasswordToggle, type, className, required, placeholder, ...props },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const inputType = showPasswordToggle ? (showPassword ? 'text' : 'password') : type;

    // Add asterisk to placeholder if required
    const displayPlaceholder = required && placeholder ? `${placeholder}*` : placeholder;

    return (
      <div className={classNames(styles.inputWrapper, className)}>
        {label && (
          <label className={styles.label}>
            {label}
            {required && <span className={styles.required}>*</span>}
          </label>
        )}
        <div className={classNames(styles.inputContainer, { [styles.hasError]: error })}>
          {icon && <span className={styles.icon}>{icon}</span>}
          <input
            ref={ref}
            type={inputType}
            className={classNames(styles.input, {
              [styles.withIcon]: icon,
              [styles.withToggle]: showPasswordToggle,
            })}
            placeholder={displayPlaceholder}
            required={required}
            {...props}
          />
          {showPasswordToggle && (
            <button
              type="button"
              className={styles.togglePassword}
              onClick={() => setShowPassword(!showPassword)}
              tabIndex={-1}
            >
              <img
                src={showPassword ? ShowEyeIcon : EyeIcon}
                alt={showPassword ? 'Hide password' : 'Show password'}
              />
            </button>
          )}
        </div>
        {error && <span className={styles.error}>{error}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;

